import produce from 'immer';

import { actionTypes } from './constants';
import * as Types from './types';

export const defaultState: Types.IBankIDAuthState = {
    formError: undefined,
    isRecaptchaShown: false,
    isExternalScriptLoaded: false,
    isWaitingForBankIdConfirmation: false
};

export const reducer = (reducerSuffix: string) =>
    produce((draftState, action: Types.TBankIDAuthAction): Types.IBankIDAuthState | void => {
        switch (action.type) {
            case actionTypes.SET_FORM_ERROR:
            case (actionTypes.SET_FORM_ERROR + reducerSuffix) as actionTypes.SET_FORM_ERROR: {
                draftState.formError = action.payload;

                break;
            }

            case actionTypes.SET_IS_EXTERNAL_SCRIPT_LOADED:
            case (actionTypes.SET_IS_EXTERNAL_SCRIPT_LOADED + reducerSuffix) as actionTypes.SET_IS_EXTERNAL_SCRIPT_LOADED: {
                draftState.isExternalScriptLoaded = action.payload;

                break;
            }

            case actionTypes.SET_IS_RECAPTCHA_SHOWN:
            case (actionTypes.SET_IS_RECAPTCHA_SHOWN + reducerSuffix) as actionTypes.SET_IS_RECAPTCHA_SHOWN: {
                draftState.isRecaptchaShown = action.payload;

                break;
            }

            case actionTypes.SET_IS_WAITING_FOR_BANK_ID_CONFIRMATION:
            case (actionTypes.SET_IS_WAITING_FOR_BANK_ID_CONFIRMATION +
                reducerSuffix) as actionTypes.SET_IS_WAITING_FOR_BANK_ID_CONFIRMATION: {
                draftState.isWaitingForBankIdConfirmation = action.payload;

                break;
            }

            default: {
                break;
            }
        }
    }, defaultState);
